import { useTooltip } from '../hooks/UNSAFE_useTooltip';
import { useTranslationBundle } from '../hooks/UNSAFE_useTranslationBundle';
import { BundleType } from '../resources/nls/bundle';
import { classNames } from '../utils/UNSAFE_classNames';
import { CompactHelpSource } from './CompactHelpSource';
import { requiredIconBase, requiredIconLabelEdgeStart } from './themes/UserAssistanceStyles.css';

type Props = {
  helpIconId?: string;
  helpSourceLink?: string;
  helpSourceText?: string;
  isRequiredShown?: boolean;
  labelEdge?: 'inside' | 'start' | 'top';
};

const CompactLabelAssistance = ({
  helpIconId,
  helpSourceLink,
  helpSourceText,
  isRequiredShown,
  labelEdge
}: Props) => {
  const translations = useTranslationBundle<BundleType>('@oracle/oraclejet-preact');
  const requiredStr = translations.userAssistance_required();

  const { tooltipContent, tooltipProps } = useTooltip({
    text: requiredStr,
    offset: { mainAxis: 8 }
  });

  const requiredStyles = classNames([
    requiredIconBase,
    labelEdge === 'start' && requiredIconLabelEdgeStart
  ]);
  const requiredIndicator = isRequiredShown && (
    <span>
      <span class={requiredStyles} {...tooltipProps} />
      {tooltipContent}
    </span>
  );

  const helpIndicator = (helpSourceLink || helpSourceText) && (
    <CompactHelpSource id={helpIconId} labelEdge={labelEdge} source={helpSourceLink}>
      {helpSourceText}
    </CompactHelpSource>
  );

  return (
    <>
      {labelEdge !== 'start' && requiredIndicator}
      {helpIndicator}
      {labelEdge === 'start' && requiredIndicator}
    </>
  );
};

export { CompactLabelAssistance };
